export function initMobileSearchBtn() {
  const btnEl = document.querySelector('.js-header-mobile-search-btn')

  if (!btnEl) {
    return
  }

  const searchEl = document.querySelector('.js-search')

  btnEl.addEventListener('click', () => {
    searchEl.classList.toggle('active')
  })
}
